import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { ICatalog } from '../models/catalog.model';
import { AngularFirestore } from 'angularfire2/firestore';
import { ENV } from '@app/env';
import { TrackingData, _TRACKING_ENTITIES } from './tracking';
import { HistoryData } from './history';
import { UtilitiesProvider } from './utilities';

import firebase from 'firebase';

@Injectable()
export class CatalogData {

  private action: 'create' | 'update' = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private afStore: AngularFirestore,
    private tracking: TrackingData,
    private historyData: HistoryData,
    private utilities: UtilitiesProvider
  ) { }

  public async createOrUpdateCatalog(client: string, catalog: ICatalog, photos: { data: string | ArrayBuffer, new: boolean, file?: File }[]) {
    if (catalog.id === "") {
      this.action = "create";
      catalog.id = this.afDb.createPushId();
      catalog.created_at = new Date().getTime()
    } else {
      this.action = "update";
      catalog.update_at = new Date().getTime()
    }
    const imageLoad = photos.map((p, i) => {
      if (p.new) {
        return this.uploadCatalogImage(p.file, catalog.id, `Image ${i}`);
      } else {
        return Promise.resolve(p.data);
      }
    });
    catalog.photos = await Promise.all(imageLoad);
    const result = this.afDb.database
      .ref(`Clients/${client}/Catalogs/${catalog.id}`)
      .update(catalog)
      .then(() => {
        return this.historyData.set(
          `Catalog content`,
          "catalog",
          this.action,
          catalog
        );
      })
      .then(() => {
        this.tracking.trackEntity(_TRACKING_ENTITIES.CATALOG, catalog.id, client, catalog, this.action);
        return catalog;
      })
      .catch(error => {
        return error;
      });
    return result;
  }

  getCatalogs(clientId: string): Observable<ICatalog[]> {
    return this.afDb.list<ICatalog>(`/Clients/${clientId}/Catalogs`,
      ref => ref.orderByChild('state').equalTo(true))
      .valueChanges();
  }

  /**
   * Retorna las calificaciones de un catalogo
   * @param catalogId
   */
  public getCatalogRankings(catalogId: string): Observable<any[]> {
    return this.afStore
      .collection(ENV.client)
      .doc('catalogs-ranking')
      .collection(catalogId, ref => ref.limit(100))
      .valueChanges();
  }

  /**
   * Consulta las estadisticas de un catalogo especifico
   * @param catalogId
   */
  public getCatalogRankById(catalogId: string) {
    return this.afDb.object<ICatalog>(`/Clients/${ENV.client}/CatalogsRank/${catalogId}`)
      .valueChanges();
  }


  public setCatalogRanking(userId: string, catalogId: string, vote: number): Promise<any> {
    const key = this.afStore.createId();
    const data = {
      created_at: firebase.firestore.FieldValue.serverTimestamp(),
      user: userId,
      catalogId,
      vote
    };
    // TODO: Se deben crear procesos almacenados para desbloquear la votación cuando se queda en true en la db
    return this.afStore
      .collection(ENV.client).doc('catalogs-ranking')
      .collection(catalogId).doc(key)
      .set(data)
      .then(() => this.afDb.object(`/Clients/${ENV.client}/CatalogsRank/${catalogId}/toCalculateRate`)
        .query.ref.transaction(() => true));
  }

  public getVoteUserProduct(userId: string, catalogId: string) {
    return this.afStore.collection(ENV.client).doc('catalogs-ranking')
      .collection(catalogId).ref.where('user', '==', userId).get();
  }

  getProductShops(clientId: string, shopId: string): Observable<ICatalog[]> {
    return this.afDb.list<ICatalog>(`/Clients/${clientId}/Catalogs`,
      ref => ref.orderByChild('shop').equalTo(shopId))
      .valueChanges();
  }

  getUserShoppingCart(clientId: string, userId: string) {
    return this.afDb.object(`/Clients/${clientId}/UserShoppingCart/${userId}`).valueChanges();
  }

  getCatalogById(clientId: string, catalogId: string) {
    return this.afDb.object<ICatalog>(`/Clients/${clientId}/Catalogs/${catalogId}`)
      .valueChanges();
  }

  getCatalogSnapById(clientId: string, catalogId: string) {
    return this.afDb.object<ICatalog>(`/Clients/${clientId}/Catalogs/${catalogId}`)
      .query.once('value');
  }

  getCatalogRef(clientId: string, catalogId: string) {
    return this.afDb.object<ICatalog>(`/Clients/${clientId}/Catalogs/${catalogId}`).query.ref;
  }

  changeStateProduct(clientId: string, catalodId: string) {
    return this.afDb.object(`/Clients/${clientId}/Catalogs/${catalodId}/state`).set(false);
  }

  userHasCatalogRecomendation(userId: string, catalogId) {
    return this.afStore.collection(ENV.client).doc('catalogs-recommendations')
      .collection(userId, ref => ref.where('catalogId', '==', catalogId))
  }

  async uploadCatalogImage(file: File, catalogId: string, name: string) {
    const task = await firebase.storage()
      .ref(`/Client/${ENV.client}/Catalogs/${catalogId}/${name}`)
      .put(file)
      .catch(err => {
        this.utilities.consoleDecorator('Upload error: ', err);
      });
    this.utilities.consoleDecorator('Snapshot: ', task);
    return task.downloadURL;
  }

}
// end file



// WEBPACK FOOTER //
// ./src/providers/catalog.ts